/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveLocationGroups from './receive-location-groups';

export default (query = { page: 1, limit: 20 }) => (dispatch) => {
    dispatch({
        type: actions.LOCATION_GROUPS_REQUEST,
    });

    return cecSdk
        .locationGroup()
        .list(query)
        .then((result) => {
            dispatch({
                type: actions.LOCATION_GROUPS_REQUEST_SUCCESS,
            });
            let locationGroups = get(result, '_embedded.items');
            dispatch(receiveLocationGroups(locationGroups));
            return result;
        })
        .catch((e) => {
            dispatch({ type: actions.LOCATION_GROUPS_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
